module.exports = __webpack_public_path__ + "static/media/menu.0fbdbc63.svg";